import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenu } from '@angular/material/menu';
import { Router } from '@angular/router';
import { AlertService } from 'app/services/alert.service';
import { GtagService } from 'app/services/gtag.service';
import { SubscriptionRestrictionService } from 'app/services/subscription-restriction.service';
import { environment } from 'environments/environment';
import { ConfirmActionDialogComponent } from '../confirm-action-dialog/confirm-action-dialog.component';
import { Store } from '@ngrx/store';
import { Quote } from 'app/entities/quote';
import { QuotesService } from '../quote-list/quotes.service';
import { PreviewQuoteComponent } from '../preview-quote/preview-quote.component';

@Component({
  selector: 'app-quote-actions',
  templateUrl: './quote-actions.component.html',
  styleUrls: ['./quote-actions.component.scss'],
  exportAs: 'menuInOtherComponent',
})
export class QuoteActionsComponent implements OnInit {
  @Input() quote!: Quote;
  @ViewChild(MatMenu, { static: true }) moreMenu!: MatMenu;
  @Output('onQuoteChanged') onQuoteChanged = new EventEmitter<Quote>();
  @Output('onQuoteDeleted') onQuoteDeleted = new EventEmitter<any>();

  env = environment;

  constructor(public _matDialog: MatDialog, private _quoteService: QuotesService, private _alertService: AlertService, private _router: Router, private _subscriptionRestrictionService: SubscriptionRestrictionService, private _store: Store, private _gtag: GtagService) {}

  ngOnInit(): void {}

  preview(event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (!this.quote?.id) {
      return;
    }

    this._quoteService.find(this.quote.id).subscribe(
      (quote) => {
        this._matDialog.open(PreviewQuoteComponent, {
          panelClass: ['form-dialog', 'big-radius-dialog', 'quote-preview-dialog'],
          width: '700px',
          maxWidth: '95vw',
          data: {
            quote,
          },
        });
      },
      (err) => {
        this._alertService.error(err);
      }
    );
  }

  orcar() {
    if (!this.quote?.id) {
      return;
    }

    this._quoteService.proposalDraft(this.quote.id).subscribe(
      (draft: any) => {
        if (draft?.alreadyConverted && draft?.proposal?.token) {
          this._router.navigate(['/propostas', draft.proposal.token]);
          return;
        }

        this._router.navigate(['/propostas', 'new'], {
          state: {
            proposalDraft: draft,
          },
        });
      },
      (err) => {
        this._alertService.error(err);
      }
    );
  }

  confirmDeleteQuote() {
    let dialog = this._matDialog.open(ConfirmActionDialogComponent, {
      panelClass: ['form-dialog'],
      data: {
        title: 'Excluir solicitação de orçamento',
        message: `Tem certeza que deseja excluir esta solicitação de orçamento?`,
      },
    });
    dialog.afterClosed().subscribe((result) => {
      if (result === true) {
        this.deleteQuote();
      } else {
      }
    });
  }

  deleteQuote() {
    this._quoteService.destroy(this.quote.id!).subscribe(
      (_) => {
        this._alertService.success('Solicitação de orçamento excluída com sucesso!');
        this._gtag.event('Quote_delete', {
          event_category: 'engagemnt',
          event_label: 'Solicitação de orçamento excluída',
        });
        this.onQuoteChanged.emit(this.quote);
        this.onQuoteDeleted.emit({});
      },
      (err) => {
        this._alertService.error(err);
      }
    );
  }
}
